import { useDispatch } from "react-redux";
import { useContext, useEffect } from "react";
import styles from "./rickmorty.module.css";
import global from "../../app.module.css";
import { Button } from "@mui/material";
import { getRMInfo } from "./reducers/actions";
import { useRMSelector } from "./reducers/store";
import { selectItems } from "./reducers/reducer";
import CartContext from "../../context/global-context";

function RMComponent(props) {
    const dispatch = useDispatch();
    const items = useRMSelector(selectItems);
    const cartCtx = useContext(CartContext);
    console.log('RMComponent.start');

    const loadUserHandler = () => {
        dispatch(getRMInfo());
    }

    const globalHttpApi = () => {
        cartCtx.getApi();
    }

    return ( 
        <div className={`${styles.contenedor} ${global.background}`}>
            <div className={styles.container} id="container">
                <div className={styles.loginCentrado}>
                    { 
                        !items ?  
                        <img className={global.logoImage} src='http://avanti-it.co/assets/img/Logo.png' alt="logo"/> :
                        <img className={global.logoImage} src={items.image} alt="logo"/>
                    }

                    { cartCtx.items && cartCtx.items.map((item, i) => <li key={i}>{item.name}</li>) }

                    <div className={`${global.row}`}>
                        <h4>RICK & MORTY</h4>
                    </div>
                    <div className={`${global.row}`}>
                        <Button 
                            variant="contained"
                            onClick={globalHttpApi}
                            className={`${styles.btn} ${styles.center}`}><span>CONTEXT ACTION...</span>
                        </Button>
                        <Button 
                            onClick={loadUserHandler} 
                            variant="contained" 
                            className={`${styles.btn} ${styles.center}`}><span>RUN RICK...</span>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RMComponent;